{
	"title": "Projekte",
	"table": {
		"reference": "Referenz",
		"quantity": "Gesamtmenge",
		"savings": "Gesamte CO₂ eq. Reduktion",
		"fetchError": "Projekte konnten nicht abgerufen werden"
	},
	"showProjectsHistoryTitle": "Projektverlauf anzeigen",
	"noProjects": {
		"createDeclaration": "Erstellen Sie Ihre erste Erklärung",
		"description": "Sie können Erklärungen für ein oder mehrere Materialien erstellen, indem Sie auf „Erklärung erstellen“ klicken”."
	}
}
